import React from 'react';
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import {Helmet} from 'react-helmet';
import { setActivitiesOpen } from '../../../actions/create-action'
import { Link } from 'react-router-dom';

import Menu from '../../Navigation/Menu'
import { store } from '../../../store';

import Navigation from '../../Navigation/Navigation';
import Footer from '../../Footer/Footer';
import {Grid, Row, Col} from 'react-bootstrap';
const mapStateToProps = (state) => {
  let open = state.activities.open
  return {
    open: open,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onOpen: (open) => dispatch(setActivitiesOpen(open)),
  }
}

class Terms extends React.Component {
   constructor(props) {
      super()
      this.state = {
         visible:false,
         mouseOverbtn: false,
         clickInside: false,
      }
      this.myRef=null
    this.handleClickOutside = this.handleClickOutside.bind(this)
    this.onMenu = this.onMenu.bind(this)
   }
   componentWillMount() {
      this.setState({visible: true})
   }
   componentWillLeave() {
      this.setState({visible: false})
   }
   componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside)
  }
   componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }
  handleClickOutside(event) {
    if(this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      return;
    }
    else if(!this.state.clickInside)
      this.props.onOpen('')
  }
  onMenu = () => {
    if(store.getState().activities.open === 'menu')
    this.props.onOpen('')
    else this.props.onOpen('menu')
  }
  onClickInside = () => {
  this.setState({clickInside: true})
  }
  onClickOutside = () => {
    this.setState({clickInside: false})
  }
   render(props) {
      return (
         <div className="container_home" ref={this.setWrapperRef}>
         <Helmet>
          <title>Terms and Conditions</title>  
          <meta name="description" content="These terms and conditions outline the rules and regulations for the use of vieww's Website, located at vieww.me" />
          <meta name="keyword" content="profile website, free profile, free site, create free profile page, professional profile, business profile" />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://app.vieww.me/terms" />
          <meta property="og:title" content="Terms and Conditions" />
          <meta name="og:description" content="These terms and conditions outline the rules and regulations for the use of vieww's Website, located at vieww.me" />
          <meta property="og:site_name" content="Terms and Conditions" />
          <meta property="twitter:card" content="summary_large_image" />
          <meta name="robots" content="index, follow" />
         </Helmet>
         <Grid fluid={true} className="container_light">
         <Row>
         <Col lg={12} md={12} sm={12} xs={12}>
         <Navigation
            onClickInside={this.onClickInside}
            onClickOutside={this.onClickOutside}
            onMenu={this.onMenu}
            location={this.props.location}/>
         </Col>
         <Col lg={10} md={10} sm={10} xs={12} className="light_inside">
         <h1 id="terms">Terms & Conditions</h1>
         <p>These terms and conditions outline the rules and regulations for the use of vieww's Website, located at <strong>vieww.me</strong>.</p>
  <p>By accessing this website we assume you accept these terms and conditions. Do not continue to use vieww if you do not agree to take all of the terms and conditions stated on this page. Our Terms and Conditions were created with the help of the Terms And Conditions Generator and the Privacy Policy Template.</p>
  
  <p>The following terminology applies to these Terms and Conditions, Privacy Statement and Disclaimer Notice and all Agreements: "Client", "You" and "Your" refers to you, the person log on this website and compliant to the Company’s terms and conditions. "The Company", "Ourselves", "We", "Our" and "Us", refers to our Company. "Party", "Parties", or "Us", refers to both the Client and ourselves. All terms refer to the offer, acceptance and consideration of payment necessary to undertake the process of our assistance to the Client in the most appropriate manner for the express purpose of meeting the Client’s needs in respect of provision of the Company’s stated services, in accordance with and subject to, prevailing law of Netherlands. Any use of the above terminology or other words in the singular, plural, capitalization and/or he/she or they, are taken as interchangeable and therefore as referring to same.</p>
  <h3>Cookies</h3>
  <p>We employ the use of cookies. By accessing vieww, you agreed to use cookies in agreement with the vieww's Privacy Policy.</p>
  <p>Most interactive websites use cookies to let us retrieve the user’s details for each visit. Cookies are used by our website to enable the functionality of certain areas to make it easier for people visiting our website. Some of our affiliate/advertising partners may also use cookies.</p>
  <h3>License</h3>
  <p>Unless otherwise stated, vieww and/or its licensors own the intellectual property rights for all material on vieww. All intellectual property rights are reserved. You may access this from vieww for your own personal use subjected to restrictions set in these terms and conditions.</p>
  <h3>You must not:</h3>
  <p>Republish material from vieww<br />
  Sell, rent or sub-license material from vieww<br />
  Reproduce, duplicate or copy material from vieww<br />
  Redistribute content from vieww<br />
  This Agreement shall begin on the date hereof.</p>
  <p>Parts of this website offer an opportunity for users to post and exchange opinions and information in certain areas of the website. vieww does not filter, edit, publish or review Comments prior to their presence on the website. Comments do not reflect the views and opinions of vieww,its agents and/or affiliates. Comments reflect the views and opinions of the person who post their views and opinions. To the extent permitted by applicable laws, vieww shall not be liable for the Comments or for any liability, damages or expenses caused and/or suffered as a result of any use of and/or posting of and/or appearance of the Comments on this website.</p>
  <p>Vieww reserves the right to monitor all Comments and to remove any Comments which can be considered inappropriate, offensive or causes breach of these Terms and Conditions.</p>
  <h3>You warrant and represent that:</h3>
  <p>You are entitled to post the Comments on our website and have all necessary licenses and consents to do so;<br />
  The Comments do not invade any intellectual property right, including without limitation copyright, patent or trademark of any third party;<br />
  The Comments do not contain any defamatory, libelous, offensive, indecent or otherwise unlawful material which is an invasion of privacy<br />
  The Comments will not be used to solicit or promote business or custom or present commercial activities or unlawful activity.<br />
  You hereby grant vieww a non-exclusive license to use, reproduce, edit and authorize others to use, reproduce and edit any of your Comments in any and all forms, formats or media.</p>
  <h3>Hyperlinking to our Content</h3>
  <p><em>The following organizations may link to our Website without prior written approval:</em></p>
  <ul>
  <li>Government agencies</li>
  <li>Search engines</li>
  <li>News organizations</li>
  <li>Online directory distributors may link to our Website in the same manner as they hyperlink to the Websites of other listed businesses</li>
  <li>System wide Accredited Businesses except soliciting non-profit organizations, charity shopping malls, and charity fundraising groups which may not hyperlink to our Web site.</li>
  </ul>
  <p><strong>These organizations may link to our home page, to publications or to other Website information so long as the link:</strong></p>
  <ol>
  <li>Is not in any way deceptive</li>
  <li>Does not falsely imply sponsorship, endorsement or approval of the linking party and its products and/or services</li>
  <li>Fits within the context of the linking party’s site.</li>
  </ol>
  <p><strong>We may consider and approve other  link requests  from the following types of organizations:</strong></p>
  <ul>
  <li>Commonly-known consumer and/or business information sources</li>
  <li>dot.com community sites</li>
  <li>Associations or other groups representing charities</li>
  <li>Online directory distributors</li>
  <li>Internet portals</li>
  <li>Accounting, law and consulting firms</li>
  <li>Educational institutions and trade associations.</li>
  </ul>
  <p><strong>We will approve link requests from these organizations if we decide that:</strong></p>
  <ol>
  <li>The link would not make us look unfavorably to ourselves or to our accredited businesses</li>
  <li>The organization does not have any negative records with us</li>
  <li>The benefit to us from the visibility of the hyperlink compensates the absence of vieww</li>
  <li>The link is in the context of general resource information.</li>
  </ol>
  <p><strong>These organizations may link to our home page so long as the link: </strong></p>
  <ol>
  <li>Is not in any way deceptive</li>
  <li>Does not falsely imply sponsorship, endorsement or approval of the linking party and its products or services</li>
  <li>Fits within the context of the linking party’s site.</li>
  </ol>
  <p>If you are one of the organizations listed in paragraph 2 above and are interested in linking to our website, you must inform us by<strong> sending an e-mail to vieww</strong>. Please include your name, your organization name, contact information as well as the URL of your site, a list of any URLs from which you intend to link to our Website, and a list of the URLs on our site to which you would like to link. Wait 2-3 weeks for a response.</p>
  <p><strong>Approved organizations may hyperlink to our Website as follows:</strong></p>
  <ul>
  <li>By use of our corporate name or</li>
  <li>By use of the uniform resource locator being linked to or</li>
  <li>By use of any other description of our Website being linked to that makes sense within the context and format of content on the linking party’s site.</li>
  <li>No use of vieww's logo or other artwork will be allowed for linking absent a trademark license agreement.</li>
  </ul>
  <h3>iFrames</h3>
  <p>Without prior approval and written permission, you may not create frames around our Webpages that alter in any way the visual presentation or appearance of our Website.</p>
  <h3>Content Liability</h3>
  <p>We shall not be hold responsible for any content that appears on your Website. You agree to protect and defend us against all claims that is rising on your Website. No link(s) should appear on any Website that may be interpreted as libelous, obscene or criminal, or which infringes, otherwise violates, or advocates the infringement or other violation of, any third party rights.</p>
  <h3>Your Privacy</h3>
  <p><em>Please read <Link to={'/privacy-policy'}>Privacy Policy</Link></em></p>
  <h3>Reservation of Rights</h3>
  <p>We reserve the right to request that you remove all links or any particular link to our Website. You approve to immediately remove all links to our Website upon request. We also reserve the right to amen these terms and conditions and it’s linking policy at any time. By continuously linking to our Website, you agree to be bound to and follow these linking terms and conditions.</p>
  <h3>Removal of links from our website</h3>
  <p>If you find any link on our Website that is offensive for any reason, you are free to contact and inform us any moment. We will consider requests to remove links but we are not obligated to or so or to respond to you directly.</p>
  <p>We do not ensure that the information on this website is correct, we do not warrant its completeness or accuracy; nor do we promise to ensure that the website remains available or that the material on the website is kept up to date.</p>
  <h3>Disclaimer</h3>
  <p>To the maximum extent permitted by applicable law, we exclude all representations, warranties and conditions relating to our website and the use of this website. Nothing in this disclaimer will:</p>
  <ul>
  <li>Limit or exclude our or your liability for death or personal injury</li>
  <li>Limit or exclude our or your liability for fraud or fraudulent misrepresentation;</li>
  <li>Limit any of our or your liabilities in any way that is not permitted under applicable law</li>
  <li>Exclude any of our or your liabilities that may not be excluded under applicable law.</li>
  </ul>
  <p>The limitations and prohibitions of liability set in this Section and elsewhere in this disclaimer:</p>
  <ol>
  <li>Are subject to the preceding paragraph</li>
  <li>Govern all liabilities arising under the disclaimer, including liabilities arising in contract, in tort and for breach of statutory duty.</li>
  </ol>
  <p>As long as the <Link to={'/'}>website</Link> and the information and services on the website are provided free of charge, we will not be liable for any loss or damage of any nature.</p>

         </Col>
         </Row>
         </Grid>
         <Footer  location={this.props.location} />
         {store.getState().activities.open === 'menu'
            ? <Menu
            onClickInside={this.onClickInside}
            onClickOutside={this.onClickOutside}
            onOpen={this.props.onOpen} />
            : null
          }
         </div>
      );
   }
}

export default connect(mapStateToProps, mapDispatchToProps)(Terms);